import React from 'react';

import Table from 'components/new_ui/Table';
import useManagers from 'components/Common/Managers/Hooks/useManagers';
import columns from './columns';

export default function Management() {
  const { loading, managers } = useManagers();

  const rowActions = [
    {
      type: 'EXPAND',
    },
  ];

  return (
    <section className="pt-0">
      <Table
        title="Management"
        columns={columns}
        data={managers}
        loading={loading}
        selectableRows={false}
        rowActions={rowActions}
      />
    </section>
  );
}
